<div class="model-main">
  <div class="container">
    <!-- Back button -->
    <div class="back-btn" (click)="goToMake()">
      <mat-icon class="go-back-to-make">keyboard_arrow_left</mat-icon>
    </div>

    <!-- Steps -->
    <div class="steps">
      <div (click)="goToMake()">Make</div>
      <div class="active">Model</div>
      <div (click)="goToMake()">Year</div>
      <div>Variant</div>
    </div>

    <!-- Title -->
    <h2>Which {{ selectedMake }} model?</h2>
    <p>Select your vehicle model from the options below</p>

    <!-- Search -->
    <div class="search-box">
      <mat-icon>search</mat-icon>
      <input
        type="text"
        [(ngModel)]="searchTerm"
        (ngModelChange)="updateFilter()"
        placeholder="Search for your car model"
      />
      <mat-icon
        class="material-icons close-btn"
        *ngIf="searchTerm"
        (click)="clearSearch()"
        >close</mat-icon
      >
    </div>

    <!-- Loading -->
    <div *ngIf="loading" class="loading">Loading models...</div>

    <!-- Model List -->
    <div class="model-list" *ngIf="!loading">
      <div
        class="model-item"
        *ngFor="let model of filteredModels"
        [class.selected]="selectedModel === model"
        (click)="selectModel(model)"
      >
        {{ model }}
      </div>
    </div>
  </div>
</div>
